// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
// import GalleryPage from './pages/GalleryPage';
// import MoodPage from './pages/MoodPage';
import ChatPage from './pages/ChatPage';
import SosPage from './pages/SosPage'; // <-- Import SOS Page
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
        {/* <Route path="/gallery" element={<ProtectedRoute><GalleryPage /></ProtectedRoute>} /> */}
        {/* <Route path="/mood" element={<ProtectedRoute><MoodPage /></ProtectedRoute>} /> */}
        <Route path="/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
        <Route path="/sos" element={<ProtectedRoute><SosPage /></ProtectedRoute>} /> {/* New Route */}
      </Routes>
    </Router>
  );
}

export default App;
